export const TERMS_OF_USE = `
<p>
    <strong>
        TERMOS DE USO
    </strong>
</p>
<p>
    <strong>
        SUMÁRIO
    </strong>
</p>
<p>
    <strong>
        1. OBJETIVO
    </strong>
</p>
<p>
    1.1 Qual o objetivo deste Sumário?
</p>
<p>
    O objetivo deste Sumário é apresentar, de forma sintetizada, as principais informações relacionadas às contratações
    realizadas por meio da plataforma {company.site} (“Portal {company.name}”), mantida pela {company.name}, uma agência
    de entretenimento online que intermedeia a venda e reserva de ingressos por meio de ferramentas de pesquisa. Essa
    intermediação ocorre entre o usuário (“Usuário”) e os produtores de eventos ou responsáveis por espaços de eventos
    (“Fornecedores”), abrangendo atividades como: (i) shows; (ii) festas; (iii) eventos esportivos; (iv) festas
    infantis; (v) peças teatrais; entre outras do ramo de entretenimento (“Serviços/Produtos de Entretenimento”). Todas
    essas contratações estão disciplinadas no Contrato de Prestação de Serviços de Intermediação, Reserva Online e Venda
    Online de Produtos de Entretenimento disponível no Portal {company.name}.
</p>
<p>
    <strong>
        2. DOCUMENTOS
    </strong>
</p>
<p>
    2.1. Quais documentos compõem a contratação?
</p>
<p>
    Compõem a contratação os“Termos de Uso”, a “Política de Privacidade, as “Condições Gerais do Contrato de Prestação
    de Serviços de Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento no Portal
    “ {company.name}.” (“Contrato”) e o Voucher, sem prejuízo de outros.
</p>
<p>
    <strong>
        3. OBRIGAÇÕES
    </strong>
</p>
<p>
    3.1 Quais as obrigações da {company.name}.?
</p>
<p>
    Intermediar a relação entre o Usuário e os Fornecedores de Produtos de Entretenimento (Produtores de Eventos /
    Espaços de Eventos) através da Plataforma {company.name}., bem como fornecer ferramentas de pesquisa de eventos e
    reserva de ingressos aos Usuários por meio da emissão de voucher ao final da compra no Portal {company.name}..
</p>
<p>
    <strong>
        3.2. Quais as obrigações dos FORNECEDORES DE PRODUTOS DE ENTRETENIMENTO?
    </strong>
</p>
<p>
    São obrigações dos Fornecedores (Produtores de Eventos / Espaços de Eventos):
</p>
<p>
    Operar a venda dos Serviços/Produtos de Entretenimento diretamente ao Usuário;
</p>
<p>
    Orientar e cientificar o Usuário acerca das especificações dos Serviços/Produtos de Entretenimento adquiridos;
</p>
<p>
    Nortear o Usuário acerca de eventuais atualizações e providências documentais, conforme o tipo dos Serviços/Produtos
    de Entretenimento adquiridos;
</p>
<p>
    Responsabilizar-se, única e exclusivamente, pelos eventuais danos e prejuízos que por acaso venham a ser causados ao
    Usuário, sucedidos durante a execução dos Serviços/Produtos de Entretenimento.
</p>
<p>
    <strong>
        3.3. Quais as obrigações do USUÁRIO?
    </strong>
</p>
<p>
    São obrigações do Usuário:
</p>
<p>
    Atentar-se às regras e disposições do Sumário; dos Termos de Uso; da Política de Privacidade; do Contrato de
    Prestação de Serviços e de Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento do
    Portal {company.name}.; das informações trazidas pelos Fornecedores; e outros;
</p>
<p>
    Efetuar o pagamento do valor do ingresso nas datas determinadas e de acordo com as formas e condições apontadas no
    Portal {company.name}.;
</p>
<p>
    Saldar o valor atinente à taxa de serviço a favor da {company.name}.(que poderá ser de até 20% -vintepor cento) sobre
    o valor do ingresso, sob as formas e condições indicadas nas regras do Contrato de Prestação de Serviços e de
    Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento do Portal {company.name}.;
</p>
<p>
    Responsabilizar-se pelo pagamento de quaisquer despesas relacionadas aos Serviços/Produtos de Entretenimento, nas
    hipóteses de cancelamento, por sua culpa exclusiva e/ou culpa de terceiros;
</p>
<p>
    Atentar-se às disposições inclusas nas descrições dos Serviços/Produtos de Entretenimento durante o processo de
    obtenção dos Serviços/Produtos de Entretenimento;
</p>
<p>
    Atentar-se aos horários, datas, locais, faixa etária e região dos Produtos de Entretenimento, informados no
    Portal {company.name}..
</p>
<p>
    <strong>
        4. VALOR DOS SERVIÇOS
    </strong>
    <strong>
        Ingresso
    </strong>
    <strong>
        S
    </strong>
    <strong>
        /
    </strong>
    <strong>
        A.
    </strong>
</p>
<p>
    4.1 Os ingressos serão acrescidos de taxa de serviçoque podem variar conforme o jogo(podendo chegar até 20%
    -vintepor cento) determinada no Contrato de Prestação de Serviços e de Intermediação, Reserva Online e Venda Online
    de Produtos de Entretenimento do Portal {company.name}..
</p>
<p>
    <strong>
        5. ALTERAÇÕES E CANCELAMENTOS
    </strong>
</p>
<p>
    5.1. Os FORNECEDORES poderão alterar as contratações?
</p>
<p>
    Os Fornecedores poderão alterar as contratações por razões operacionais, obrigando-se a observar, a todo tempo, o
    mesmo padrão de qualidade contratado pelo Usuário, reembolsando eventuais pedidos de cancelamento requeridos pelo
    Usuário diante às alterações.
</p>
<p>
    5.2. O USUÁRIO poderá cancelar a contratação?
</p>
<p>
    5.2.1 O Usuário somente poderá cancelar a contratação se efetuar o requerimento em até 07 (sete) dias corridos após
    a compra, desde que este prazo não ultrapasse 24h antes do evento.
</p>
<p>
    5.2.2. Estando dentro do prazo previsto, o Usuário poderá acessar o portal {company.site}, selecionar o menu “Meus
    Ingressos” e clicar no botão de cancelamento referente ao(s) ingresso(s) que deseja cancelar. Alternativamente, o
    cancelamento poderá ser solicitado por meio do e-mail cadastrado na plataforma, mediante envio de mensagem para
    contato@ {company.name} , informando o número do pedido a ser cancelado.
</p>
<p>
    5.2.3 O valor do(s) ingresso(s) adquirido(s) será(ão) restituído(s), salvo a taxa de serviço,que não será
    reembolsada.
</p>
<p>
    5.2.4 A {company.name}.não faz cancelamento/estorno parcial, ou seja, ao solicitar cancelamento, todos os ingressos
    do pedido serão cancelados/estornados.
</p>
<p>
    5.3. Quais as implicações do cancelamento de Serviços/Produtos de Entretenimento designados em feriado ou datas
    festivas?
</p>
<p>
    5.3.1 O cancelamento de Serviços/Produtos de Entretenimento designados em feriado ou datas festivas – como carnaval,
    réveillon e outros – poderá implicar na perda de 20% (vinte por cento) a 30% (trinta por cento) do valor do
    Serviço/Produto de Entretenimento, a depender do seu tipo e/ou dos procedimentos e das políticas operacionais
    aplicadas pelos Fornecedores.
</p>
<p>
    5.4. E se houver valor a ser reembolsado ao USUÁRIO?
</p>
<p>
    A restituição de valor ao Usuário será realizada de acordo com o método de pagamento utilizado no momento da compra.
</p>
<p>
    5.4.1 Compra realizada via cartão de crédito será creditada em até 60 (sessenta) dias de acordo com a data de
    fechamento da fatura do cartão e das instituições envolvidas no estorno. Para saber mais sobre os prazos, sugerimos
    que entre em contato diretamente com sua operadora de cartão;
</p>
<p>
    5.4.2 Compra realizada via PIX a devolução de pagamento é feita via PIX, somente na conta bancária de origem da
    compra, o Usuário deve verificar o reembolso em seu extrato bancário;
</p>
<p>
    5.5. Quais os canais de atendimento para os pedidos de cancelamento?
</p>
<p>
    O cancelamento deve ser solicitadodiretamente na árealogadado usuário no site da {company.name} ou pelos canais de
    atendimento como:e-mail:ouwhatsapp: (11)91586-4884, informando o número do pedido que deseja cancelare estando
    dentro das condições listadas na clausula5.
</p>
<p>
    <strong>
        6. INFORMAÇÕES ÚTEIS
    </strong>
</p>
<p>
    6.1 A conclusão da compra está sujeita à disponibilidade de ingresso no Portal {company.name}., bem como à aprovação
    da transação pela plataforma de pagamentos online (gateway de pagamento) e pela administradora do cartão de crédito
    do Usuário (Visa, Mastercard e outros).
</p>
<p>
    6.2 Os ingressos serão acrescidos de taxa de serviço determinada no Contrato de Prestação de Serviços e de
    Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento do Portal {company.name}..
</p>
<p>
    6.3A cobrança da taxa de serviço decorre da disponibilização, pela {company.name}, das ferramentas de pesquisa,
    reserva de ingressos e intermediação na aquisição de ingressos para eventos de entretenimento, permitindo ao Usuário
    acessar opções com melhor preço, categoria, cidade, data, horário e região, entre os Produtores e Espaços de Eventos
    cadastrados na plataforma.
</p>
<p>
    6.4 Os pedidos de compra estão sujeitos à concordância do Usuário aos Termos de Uso do site, bem como à confirmação
    do pagamento. O Usuário, para tanto, declara ter lido e aceito as disposições e regras contidas neste Termo de Uso,
    além de conhecer e aceitar que as informações solicitadas sejam utilizadas para atestar a veracidade dos dados do
    comprador e aprovação do crédito.
</p>
<p>
    6.5 Finalizada a compra, se identificada qualquer inconsistência de dados junto a administradora do cartão de
    crédito utilizado para o pagamento, o pedido poderá ser cancelado pela plataforma de pagamentos online ou pela
    administradora do cartão.
</p>
<p>
    6.6 O Voucher terá validade apenas se apresentado junto com os documentos de identificação com foto – Carteira de
    Identidade (RG), Carteira Nacional de Habilitação (CNH) ou Passaporte – e junto com o cartão utilizado para a compra
    do ingresso. Não será aceito outro tipo de documento além dos acima descritos. Sendo o Voucher com entrada direta,
    não será realizada a troca antecipada.
</p>
<p>
    6.7 A {company.name}.é apenas intermediária, seja na venda do ingresso ou na reserva. Os Fornecedores
    (Produtores/Espaços dos Eventos) são os únicos responsáveis pela realização,adiamento ou cancelamento do evento, bem
    como por todos os fatos oriundos destes, e, também, são os únicos responsáveis pela restituição do valor(es) do(s)
    ingresso(s) nos casos previstos em lei.
</p>
<p>
    6.8. Após a aprovação da compra, o voucher será enviado para o e-mail do titular e também ficará disponível no site.
    Para acessá-lo, basta realizar login com o e-mail e a senha cadastrados.
</p>
<p>
    6.9 A {company.name}.não possui qualquer responsabilidade acerca de furtos e roubos acontecidos durante a execução
    dos Serviços/Produtos de Entretenimento adquiridos pelo Usuário.
</p>
<p>
    6.10 Será cobrada uma taxa de juros, a ser conferida no ato da compra/parcelamento, referente à operação de crédito,
    cobrada pelo gateway de pagamento, no caso de parcelamento da compra do ingresso. O reembolso é realizado
    integralmente pela administradora, com exceção das multas aplicáveis, de modo que as parcelas continuarão sendo
    debitadas normalmente no cartão de crédito.
</p>
<p>
    6.11 O Usuário é responsável, sem prejuízo do Sumário; dos Termos de Uso; da Política de Privacidade; do Contrato de
    Prestação de Serviços e de Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento do
    Portal {company.name}.; das informações trazidas pelos Fornecedores; e outros:
</p>
<p>
    Por prover e transportar todos os documentos necessários para admissão nos eventos – documento de identidade
    original, incluindo os de crianças de colo e menores de idade, especialmente autorização do responsável legal válida
    legalmente;
</p>
<p>
    Pelos dispêndios relacionados às eventuais taxas governamentais cobradas em outros países, bem como pela obtenção de
    visto, estando o Usuário ciente de que, ainda que deferido ou desnecessário o visto para determinado país, poderá
    haver a negativa de sua entrada territorial, visto que a deportação é ato discricionário da autoridade do país, não
    podendo a {company.name}.ser responsabilizada por qualquer devolução de valores ou pagamento indenizatório ao
    Usuário;
</p>
<p>
    Por averiguar o horário de entrada de eventos, sabendo que estes poderão variar conforme a descrição dos
    Serviços/Produtos de Entretenimento constantes no Portal {company.name}..As informações específicas poderão ser
    obtidas pelo Usuário, das 09h00min às 18h00min, exceto aos domingos e feriados, no Portal {company.name}., pelo
    e-mailouwhatsapp: (11)91586-4884, ou em contato direto com os Fornecedores (Produtores/Espaços de Eventos);
</p>
<p>
    Pela ciência de que os Serviços/Produtos de Entretenimento, objeto do Termo e deste Sumário, são exclusivamente
    aqueles descritos no ato em que o Usuário os adquiriu por intermédio do Portal {company.name}., não havendo qualquer
    responsabilidade da {company.name}.quanto a outros Serviços/Produtos de Entretenimento eventualmente contratados pelo
    Usuário antes, durante ou após a realização do evento, sem a sua intermediação e sem ser realizada por meio do site
    {company.site};
</p>
<p>
    Por declarar sua condição de portador de necessidades especiais no ato em que adquirir os Serviços/Produtos de
    Entretenimento através do Portal {company.name}., bem como verificar/ponderar a viabilidade da execução dos
    Serviços/Produtos de Entretenimento adquiridos. Cientifica-se que há eventos em que podem não ser possíveis de se
    realizar por portadores de determinadas necessidades especiais, estando ainda ciente de que não haverá qualquer
    compensação financeira/devolução de valores por parte da {company.name}.na hipótese de impossibilidade quanto à
    realização de determinados Serviços/Produtos de Entretenimento.
</p>
<p>
    6.12 O Usuário efetuará o pagamento pelos Serviços/Produtos de Entretenimento adquiridos conforme descrição contida
    no ato da correspondente operação junto ao site {company.site}.
</p>
<p>
    Esse é o Sumário do Contrato de Prestação de Serviços de Intermediação, Reserva Online e Venda Online de Produtos de
    Entretenimento no Portal {company.name}., a seguir disposto, em seu inteiro teor:
</p>
<p>
    <strong>
        Contrato De Prestação de Serviços De Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento
        no Portal
    </strong>
    <strong>
        Ingresso
    </strong>
    <strong>
        S
    </strong>
    <strong>
        /
    </strong>
    <strong>
        A.
    </strong>
</p>
<p>
    <strong>
        Considerações iniciais:
    </strong>
</p>
<p>
    (i) A {company.name} é uma empresa que disponibiliza em seu domínio ({company.site}) uma ferramenta de pesquisa de
    eventos com filtro de buscas desenvolvidos pelo site, a fim de aquisição e reserva de ingressos online, de modo que
    exerce a intermediação do Usuário e dos Fornecedores de Produtos de Entretenimento, tais como shows, festas, jogos
    esportivos, festas infantis, peças teatrais, dentre outros.;
</p>
<p>
    (ii) O CLIENTE (Usuário), sob sua responsabilidade, insere os critérios de pesquisa, sem limites, como (a) data, (b)
    cidade, (c) região, (d) preço, (e) categoria, (f) horários e outros;
</p>
<p>
    (iii) A partir dos critérios de pesquisa informados pelo CLIENTE, a {company.name} indica o resultado da pesquisa,
    podendo ser ordenado pelos melhores preços encontrados;
</p>
<p>
    (iv) Ao inserir os dados de pagamento, a cobrança é realizada por meio do sistema dos“Fornecedores”– Produtores de
    Eventos; Espaços de Eventos e Estádios de Futebol;
</p>
<p>
    (v) Os Fornecedores enviam o Voucher à {company.name} , o qual é imediatamente enviado ao CLIENTE, após a aprovação
    pela administradora do cartão de crédito utilizado pelo CLIENTE e a confirmação da compra; portanto, é necessário
    conferir os dados ao efetuar o cadastro ou no campo e-mail da conta cadastrada para garantir que estão corretos, do
    contrário, é possível que o CLIENTE não receba o documento de entrada nos Produtos de Entretenimento;
</p>
<p>
    (vi) A {company.name} funciona como intermediária entre os Fornecedores de Serviços/Produtos de Entretenimento e
    Consumidores, tão somente quanto à venda no Portal {company.name}., subsidiando o melhor preço, categoria, cidade,
    data, horários e região dentre os Produtores/Espaços de Eventos cadastrados.
</p>
<p>
    (vii) Os ingressos serão acrescidos de taxa de serviço determinada no Contrato de Prestação de Serviços e de
    Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento do Portal {company.name}..
</p>
<p>
    (viii) A cobrança da taxa de serviço é proveniente da {company.name}.fornecer aos Usuário do Portal {company.name}.as
    ferramentas de pesquisa, reserva de ingressos e intermediação na obtenção dos diversos ingressos para eventos de
    entretenimento, subsidiando o melhor preço, categoria, cidade, data, horários e região dentre os Produtores/Espaços
    de Eventos cadastrados.
</p>
<p>
    <strong>
        (ix) As taxas de serviço não serão reembolsadas, pois, com a confirmação do pagamento pelo Usuário, a reserva do
        ingresso (serviço disponibilizado pela
    </strong>
    <strong>
        Ingresso
    </strong>
    <strong>
        S
    </strong>
    <strong>
        /
    </strong>
    <strong>
        A.
    </strong>
    <strong>
        ) é efetivada. Para casos de parcelamento com cartão de crédito, o reembolso é realizado integralmente pela
        administradora, com exceção das multas aplicáveis, de modo que as parcelas continuarão sendo debitadas
        normalmente no cartão de crédito.
    </strong>
</p>
<p>
    As partes têm entre si, justo e acordado, o presente Contrato De Prestação de Serviços De Intermediação, Reserva
    Online e Venda Online de Produtos de Entretenimento no Portal {company.name}., que se regerá pelas cláusulas e
    condições a seguir expostas:
</p>
<p>
    <strong>
        1. PRODUTOS DE ENTRETENIMENTO
    </strong>
</p>
<p>
    1.1 A pesquisa feita pelo CLIENTE sobre eventos, domésticos ou internacionais, a partir dos critérios por ele
    inseridos, terá como resultado os melhores preços e condições de pagamento encontradas dentre os Produtos de
    Entretenimento oferecidos pelos Fornecedores de Serviços/Produtos de Entretenimento para os quais a {company.name} faz
    intermediação e reserva de ingressos. Compreendendo-se que os valores dos ingressos são dinâmicos e sujeitos a
    alterações a qualquer tempo e sem aviso prévio, logo, dependendo do tempo de finalização da compra, pode ocorrer
    variação de preço entre a escolha do evento e a finalização de compra pelo CLIENTE.
</p>
<p>
    1.2 Após a escolha do melhor evento pelo CLIENTE, este deverá inserir imediatamente os dados do(s) compradores(s) e
    da compra (favor verificar o item abaixo "Uso do Cartão de Crédito").
</p>
<p>
    1.3 Ao concluir o processo de compra, o CLIENTE receberá um e-mail com a confirmação do pedido (atente-se que o
    e-mail esteja correto). A aquisição de eventos está condicionada à sua efetiva ratificação pelo Fornecedor
    (Produtores de Eventos / Espaços de Eventos) escolhido.
</p>
<p>
    1.4 A cobrança dos valores relativos à obtenção dos Produtos de Entretenimento é sempre feita no sistema eletrônico
    dos respectivos Fornecedores (Produtores de Eventos / Espaços de Eventos).
</p>
<p>
    1.5 A {company.name} , na qualidade de intermediária do serviço de reserva e compra e venda online dos Produtos de
    Entretenimento no Portal {company.name}., deverá ser diligente ao exigir dos Fornecedores a devolução de todo e
    qualquer valor da compra online eventualmente devido por estes ao {company.name}., a exemplo, mas não se limitando, a
    erros de cobrança e reembolso.
</p>
<p>
    1.6 Os Produtos de Entretenimento podem ser operados pelos Produtores de Eventos escolhidos pelos CLIENTES ou por
    outros produtores parceiros daquele. Esta decisão é sempre dos Produtores de Eventos, sem qualquer interferência
    da {company.name} .
</p>
<p>
    1.7 Os Produtos de Entretenimento possuem validade máxima, a partir da data da compra, até a data do
    evento/acontecimento, sendo possível sua utilização e cancelamento apenas dentro deste prazo, estando sujeito a
    eventuais multas e taxas impostas pelos Produtores de Eventos.
</p>
<p>
    1.8 Produtos de Entretenimento promocionais podem não ser reembolsáveis e não permitir cancelamentos, sendo
    necessária a leitura do item abaixo “Cancelamentos”.
</p>
<p>
    1.9 A {company.name} , enquanto intermediária do serviço de reserva e compra e venda online dos Produtos de
    Entretenimento, não se responsabiliza por todo e qualquer “serviço de porta” ou chargeback que eventualmente venha a
    ser solicitado pelo CLIENTE, sendo de única e exclusiva responsabilidade dos Fornecedores o controle de entrada nos
    eventos.
</p>
<p>
    <strong>
        2. DEVERES DO CLIENTE
    </strong>
</p>
<p>
    2.1 Fornecer informações completas e atualizadas mediante as solicitações do site no processo de obtenção dos
    Produtos de Entretenimento;
</p>
<p>
    2.2 Proceder com zelo e atenção no processo de obtenção dos Produtos de Entretenimento, incluindo informações
    corretas e verdadeiras, sendo o único responsável por estas informações;
</p>
<p>
    2.3 Observar as regras deste Sumário; dos Termos de Uso; da Política de Privacidade; do Contrato de Prestação de
    Serviços de Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento no Portal {company.name}.; das
    informações trazidas pelos Fornecedores; e outros;
</p>
<p>
    2.4 Efetuar o pagamento do valor do ingresso nas datas determinadas e de acordo com as formas e condições apontadas
    no Portal {company.name}.;
</p>
<p>
    2.5 Saldar o valor atinente à taxa de serviço a favor da {company.name}.(até 20% -vintepor cento) sobre o valor do
    ingresso, sob as formas e condições indicadas nas regras do Contrato de Prestação de Serviços e de Intermediação,
    Reserva Online e Venda Online de Produtos de Entretenimento do Portal {company.name}.;
</p>
<p>
    2.6 Responsabilizar-se pelo pagamento de quaisquer despesas relacionadas aos Serviços/Produtos de Entretenimento,
    nas hipóteses de cancelamento, por sua culpa exclusiva e/ou culpa de terceiros;
</p>
<p>
    2.7 Atentar-se às disposições inclusas nas descrições dos Serviços/Produtos de Entretenimento durante o processo de
    obtenção dos Serviços/Produtos de Entretenimento;
</p>
<p>
    2.8 Comparecer aos eventos no horário informado na "Descrição" do evento, estas estabelecidas pelo Produtor de
    Eventos e Espaços de Eventos, contido no Portal {company.name}.;
</p>
<p>
    2.9 Verificar o fuso horário do local do Produto de Entretenimento, bem como o horário de verão;
</p>
<p>
    2.10 Apresentar todos os documentos necessários para a entrada nos eventos;
</p>
<p>
    2.11 Verificar quais os documentos necessários para a entrada de crianças de colo e menores de idade;
</p>
<p>
    2.12 Obedecer a todas as normas de segurança estipuladas pelos Fornecedores (Produtores do Eventos e Espaços de
    Eventos), bem como por suas empresas interpostas, tais como empresas de segurança; portaria; limpeza; áudio e demais
    correlacionadas;
</p>
<p>
    2.13 Reclamar, em até 30 (trinta) dias, por qualquer problema ocorrido na compra online no Portal {company.name}.e/ou
    utilização dos ingressos dos Produtos de Entretenimento adquiridos no Portal {company.name}., sob pena de não mais
    poder fazê-lo, conforme determina o artigo 26, inciso I, do Código de Defesa do Consumidor.
</p>
<p>
    <strong>
        3. REGRAS DA TAXA DE SERVIÇO E PENALIDADES
    </strong>
</p>
<p>
    3.1 Os ingressos serão acrescidos, além dos tributos, de taxa de serviço (até 20% -vintepor cento) determinada no
    Contrato de Prestação de Serviços de Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento no
    Portal {company.name}..
</p>
<p>
    3.2 A cobrança da taxa de serviço é proveniente da {company.name}.fornecer aos Usuário do Portal {company.name}.as
    ferramentas de pesquisa, reserva de ingressos e intermediação na obtenção dos diversos ingressos para eventos de
    entretenimento, subsidiando o melhor preço, categoria, cidade, data, horários e região dentre os Produtores/Espaços
    de Eventos cadastrados.
</p>
<p>
    3.3 As taxas de serviço não serão reembolsadas, salvo as hipóteses previstas na política de alterações e
    cancelamento (vide item abaixo).
</p>
<p>
    <strong>
        4. ALTERAÇÕES E CANCELAMENTOS
    </strong>
</p>
<p>
    4.1 Os Fornecedores poderão alterar as contratações por razões operacionais, obrigando-se a observar, a todo tempo,
    o mesmo padrão de qualidade contratado pelo Usuário, reembolsando eventuais pedidos de cancelamento requeridos pelo
    Usuário diante às alterações.
</p>
<p>
    4.2 O CLIENTE somente poderá cancelar a contratação se efetuar o requerimento em até 07 (sete) dias corridos após a
    compra, desde que este prazo também não ultrapasse 24h antes do evento. Se o CLIENTE estiver dentro do prazo, é
    suficiente solicitar o cancelamento, única e exclusivamente, via e-mail:, por meio do e-mail cadastrado na
    plataforma {company.name}.informando o número do pedido que deseja cancelar, sendo aplicada a dedução prevista.
</p>
<p>
    4.3 No caso de cancelamento dos Serviços/Produtos de Entretenimento, a pedido unilateral do CLIENTE, faltando menos
    de 24h para a abertura dos portões do evento, serão deduzidas 20% (vinte por cento) do valor da compra, referente
    aos serviços prestados pela {company.name}..
</p>
<p>
    4.4 O cancelamento de Serviços/Produtos de Entretenimento designados em feriado ou datas festivas – como carnaval,
    réveillon e outros – poderá implicar na perda de 20% (vinte por cento) a 30% (trinta por cento) do valor do
    Serviço/Produto de Entretenimento, a depender do seu tipo e/ou dos procedimentos e das políticas operacionais
    aplicadas pelos Fornecedores.
</p>
<p>
    4.5 O cancelamento poderá ser realizado somente pelo e-mail:.
</p>
<p>
    <strong>
        5. REEMBOLSO AOS CLIENTES
    </strong>
</p>
<p>
    5.1 O reembolso de valor ao CLIENTE, nos casos aqui previstos, será realizado pelo mesmo método utilizado na compra.
    Para compras realizadas via cartão de crédito será creditado em até 60 (sessenta) dias no cartão de crédito
    utilizado para a obtenção do Serviço/Produto de Entretenimento.
</p>
<p>
    5.2 Para casos de parcelamento com cartão de crédito, o reembolso é realizado integralmente pela administradora, com
    exceção das multas aplicáveis, de modo que as parcelas continuarão sendo debitadas normalmente no cartão de crédito,
    conforme a forma de pagamento utilizada, devido ao tempo de ressarcimento aplicado pela administradora do cartão de
    crédito depois de pedido de devolução; deste modo não cabe unicamente à administradora do cartão reembolsar, não
    sendo reembolsado qualquer valor pela {company.name}..
</p>
<p>
    <strong>
        6. USO DE CARTÃO DE CRÉDITO
    </strong>
</p>
<p>
    6.1 A obtenção de qualquer Produto de Entretenimento pelo CLIENTE no site da {company.name} só poderá ser efetuada
    pelas bandeiras de cartão de crédito disponibilizadas no site Portal {company.name}..
</p>
<p>
    6.2 O CLIENTE deverá fazer uso de cartão de crédito válido e emitido no Brasil.
</p>
<p>
    6.3 O CLIENTE deverá proceder com atenção no processo de inserção dos dados do cartão de crédito, evitando erro de
    digitação do número do cartão, da data de validade, do dígito verificador ou de qualquer outra informação
    relacionada ao cartão. No caso de dados erroneamente preenchidos, o CLIENTE fica ciente de que a compra não será
    finalizada com sucesso, bem como deverá efetuar nova solicitação de compra e estará novamente sujeito às condições
    de disponibilidade neste novo momento.
</p>
<p>
    6.4 Após a inserção dos dados do CLIENTE e do cartão utilizado para pagamento do Produto de Entretenimento
    selecionado, o processamento destas informações e a realização da cobrança serão feitos no sistema dorespectivo
    Fornecedor, sendo o site da {company.name}.uma interface (ligação) entre o CLIENTE e o sistema do(s) Fornecedor(es),
    responsáveis pelo processamento das informações e cobrança dos valores dos Produtos de Entretenimento.
</p>
<p>
    6.5 A compra do Produto de Entretenimento poderá ser cancelada caso o cartão de crédito utilizado não seja aprovado
    pela plataforma de pagamentos online ou pela administradora do cartão e/ou pelo sistema de cobrança do(s)
    Fornecedor(es), sem qualquer responsabilidade e/ou ingerência da {company.name} , já que referida empresa não faz
    análise de crédito.
</p>
<p>
    <strong>
        7. RESPONSABILIDADES E EXCLUSÕES DE RESPONSABILIDADE
    </strong>
</p>
<p>
    7.1 Os Fornecedores (Produtores/Espaços de Eventos) são os únicos responsáveis pelos eventuais danos e prejuízos que
    por acaso venham a serem causados ao CLIENTE, sucedidos durante a execução dos Produtos de Entretenimento.
</p>
<p>
    A {company.name} não se responsabiliza:
</p>
<p>
    Por atraso do início ou conclusão do Produto de Entretenimento;
</p>
<p>
    Por atraso do início ou conclusão do Produto de Entretenimento;
</p>
<p>
    Por longas filas de espera na entrada/saída do Produto de Entretenimento;
</p>
<p>
    Por superlotação do Produto de Entretenimento;
</p>
<p>
    Por alteração de data ou horário do Produto de Entretenimento;
</p>
<p>
    Por lesões corporais ou acidentes ocorridos ao CLIENTE durante a realização do evento do Produto de Entretenimento;
</p>
<p>
    Por extravio, danos ou prejuízos aos bens materiais do CLIENTE;
</p>
<p>
    Pela impossibilidade de obtenção de qualquer Produto de Entretenimento ou por quaisquer danos ou prejuízos, em razão
    da indisponibilidade total ou parcial de seu site;
</p>
<p>
    Por quaisquer danos ou prejuízos ocorridos ao CLIENTE decorrentes da obtenção de qualquer Produto de Entretenimento
    não efetivada em razão de indisponibilidade total ou parcial do sistema de cobrança e processamento de informações
    do(s) Fornecedor(es);
</p>
<p>
    Por quaisquer vendas em outros Pontos de Vendas, isto é, compras que não sejam realizadas de forma online no
    Portal {company.name}.; isto porque o(s) Fornecedor(es) são livres para escolher todos os pontos de vendas, sejam
    online ou físicos.
</p>
<p>
    <strong>
        8. DA PROTEÇÃO DE DADOS PESSOAIS
    </strong>
</p>
<p>
    8.1A proteção dos dados pessoais dos nossos clientes e parceiros comerciais é prioridade para a {company.name}. Essa
    proteção está fundamentada na Lei nº 13.709/2018 (Lei Geral de Proteção de Dados – LGPD), por meio da qual o CLIENTE
    poderá exercer seus direitos e esclarecer eventuais dúvidas.
</p>
<p>
    8.1.1 Caso o CLIENTE deseje mais informações ele pode consultar a nossa POLÍTICA DE PRIVACIDADE();
</p>
<p>
    8.1.2 Caso o CLIENTE ainda fique com alguma dúvida ele pode entrar em contato conosco por meio dos nossos canais de
    atendimentos, entrando em contado com o contato@ {company.name} ;
</p>
<p>
    8.2Caso o CLIENTE ainda tenha dúvidas, poderá entrar em contato conosco por meio dos nossos canais de atendimento,
    especialmente pelo e-mail: contato@ {company.name} .
</p>
<p>
    8.3O tratamento de dados pessoais pela {company.name} está fundamentado nas hipóteses legais previstas na Lei nº
    13.709/2018 (Lei Geral de Proteção de Dados – LGPD), incluindo, mas não se limitando a: (i) execução de contrato ou
    de procedimentos preliminares a pedido do titular (art. 7º, V); (ii) cumprimento de obrigação legal (art. 7º, II); e
    (iii) legítimo interesse do controlador, observadas as legítimas expectativas do titular e os seus direitos
    fundamentais (art. 7º, IX). As bases legais aplicáveis a cada operação de tratamento estão descritas na Política de
</p>
<p>
    8.4 Caso o CLIENTE opte por não compartilhar mais seus dados, cabe ao mesmo o direito de fazer a exclusão de sua
    própria conta na plataforma,bastando para isso que o cliente faça seu login como usuário, depois clique em seu nome
    na parte superior direita do site, em seguida em “meu perfil”. Feito isso ele poderá clicar em “excluir conta”o que
    garante que não terá mais seus dados em nosso banco de dados para quaisquer finalidades.
</p>
<p>
    <strong>
        9. DISPOSIÇÕES GERAIS
    </strong>
</p>
<p>
    9.1 O CLIENTE deve se certificar do Produto de Entretenimento escolhido sobre a data, horário, local, região,
    categoria, bem como os horários de abertura dos portões.
</p>
<p>
    9.2 Não poderá ser feita, em momento algum, a entrada antes do horário permitido.
</p>
<p>
    9.3 O CLIENTE, ao adquirir qualquer Produto de Entretenimento, aceita e concorda com todos os Termos de Uso e a
    Política de Privacidade do site da {company.name}.({company.site}).
</p>
<p>
    9.4 A intermediação e reserva é exclusivamente relacionada à compra e venda online de Produtos de Entretenimento tão
    somente no Portal {company.name}..
</p>
<p>
    <strong>
        10. FORO
    </strong>
</p>
<p>
    10.1 O presente contrato é regido pelas leis da República Federativa do Brasil e pelos Tratados e Convenções
    Internacionais dos quais o Brasil é signatário, ficando eleito o Foro da Comarca de Goiânia-GO para dirimir qualquer
    dúvida, pendência ou litígio oriundo deste contrato, com expressa renúncia de qualquer outro, por mais privilegiado
    que seja ou venha a ser.
</p>
<p>
    <strong>
        11. CESSÃO DE USO DE IMAGEM
    </strong>
</p>
<p>
    11.1. Durante a realização dos eventos, poderá haver captação de imagens, vídeos e sons dos participantes, inclusive
    do CLIENTE, com a finalidade de promover, divulgar e registrar as atividades promovidas ou intermediadas pela
    {company.name}. Esse tratamento de dados pessoais está fundamentado no legítimo interesse da {company.name},
    conforme previsto noart. 7º, IX, da Lei nº 13.709/2018 (LGPD), respeitadas as expectativas do titular, seus direitos
    e liberdades fundamentais.
</p>
<p>
    11.2. Ao participar do evento, o CLIENTE reconhece e concorda com a possibilidade de uso gratuito de sua imagem,
    nome e voz pela {company.name} para fins institucionais e promocionais, em materiais de divulgação, publicações,
    mídias sociais, sites e demais canais oficiais da empresa, sem limite de tempo ou número de veiculações.
</p>
<p>
    11.3. A {company.name} não se responsabiliza pelo uso de imagem e som realizado por terceiros, como promotores,
    patrocinadores, veículos de imprensa ou demais participantes do evento, cuja coleta ou divulgação não seja realizada
    por ordem ou sob responsabilidade da {company.name}. Nesses casos, o tratamento dos dados será de responsabilidade
    dos respectivos terceiros, que deverão fornecer informações e garantias próprias sobre a conformidade com a
    legislação aplicável.
</p>
<p>
    <strong>
        12. INFORMA
    </strong>
    <strong>
        ÇÕES Ú
    </strong>
    <strong>
        TEIS
    </strong>
</p>
<p>
    12.1 A finalização da compra está sujeita à disponibilidade de ingressos no sistema do Portal da {company.name}.,bem
    como à aprovação da transação pela plataforma de pagamentos online (Mercado Pago–PagSeguro–Picpay– ou outra que a
    Ingresso S/A disponibilizar aos seus clientes) e pela administradora do cartão de crédito do Usuário (Visa,
    Mastercard, dentre outros);
</p>
<p>
    12.2 Os pedidos de compra estão condicionadosàconcordância do usuário/consumidor aos termos de uso do site, além da
    confirmação do pagamento. O Usuário declara ter lido e aceito as regras constantes do presente termo de uso do site,
    além de conhecer e aceitar que as informações solicitadas sejam utilizadas para confirmar a veracidade dos dados do
    comprador e aprovação do crédito.
</p>
<p>
    12.3Apósa conclusão da compra, caso seja identificada qualquer inconsistência de dados junto a administradora do
    cartão de crédito utilizado para pagamento, o pedido poderá ser cancelado pela plataforma de pagamentos online ou
    pela administradora do cartão de crédito;
</p>
<p>
    12.4Apósa compra aprovada o Voucher será encaminhado para o e-mail do titular da compra;
</p>
<p>
    12.5 O Voucher sóterá validade se apresentado juntamente com um dos seguintes documentos de identificação com foto:
    Carteira de Identidade (RG), Carteira nacional de Habilitação (CNH) ou Passaporte e CARTÃO utilizado para a compra
    do ingresso. Não será aceito outro tipo de documento além dos acima descritos. Em casos de VOUCHER com entrada
    direta, não será realizado a troca antecipada;
</p>
<p>
    12.6 A {company.name}., não possui qualquer responsabilidade quanto aos furtos e roubos ocorridos durante a execução
    dos Serviços/Produtos de Entretenimento adquiridos pelos Usuários;
</p>
<p>
    12.7. Nos ingressos adquiridos para os jogos da FIBA por meio da {company.name}, o comprador poderá receber
    comunicações sobre eventos, produtos, ofertas e pesquisas promovidas pela FIBA e seus parceiros oficiais. Esse
    tratamento de dados está fundamentado no legítimo interesse da FIBA, controladora dos dados para tais fins, nos
    termos do art. 7º, IX, da Lei nº 13.709/2018 (LGPD).
</p>
<p>
    O CLIENTE poderá, a qualquer momento, manifestar sua oposição ao recebimento dessas comunicações, conforme previsto
    na Política de Privacidade da FIBA ou por meio dos canais de atendimento disponibilizados por ela.
</p>
<p>
    ​–Leia a política de privacidade da FIBA​​:
</p>
<p>
    12.8Ao adquirir, possuir ou utilizar de qualquer forma o presente ingresso, o titular aceita e concorda em cumprir
    as Regras do Local da FIBA, que estão disponíveis emou nas bilheterias e/ou centros de credenciamento do evento.
</p>
<p>
    <strong>
        13. DISPOSIÇÕES FINAIS
    </strong>
</p>
<p>
    13.1. Este Termo de Uso, juntamente com a Política de Privacidade e o Contrato de Prestação de Serviços de
    Intermediação, Reserva Online e Venda Online de Produtos de Entretenimento no Portal {company.name}, constitui o
    acordo integral entre as partes, prevalecendo sobre quaisquer entendimentos anteriores, verbais ou escritos,
    relacionados ao seu objeto.
</p>
<p>
    13.2. A nulidade ou inexequibilidade de qualquer disposição deste Termo não afetará a validade e a eficácia das
    demais disposições, que permanecerão em pleno vigor e efeito.
</p>
<p>
    13.3. A tolerância quanto ao descumprimento de quaisquer cláusulas ou condições deste instrumento não constituirá
    renúncia ou novação, nem impedirá que a parte tolerante, a qualquer tempo, exija o fiel e cabal cumprimento das
    disposições ora pactuadas.
</p>
<p>
    13.4. Ao utilizar a plataforma da {company.name}, o CLIENTE declara que leu, compreendeu e aceitou integralmente as
    disposições deste Termo de Uso, obrigando-se a cumpri-las em sua totalidade.
</p>`